import React from 'react';

import './loadingIcon.scss';

export function renderLoadingIcon(extraClass: string = ''): JSX.Element {
    return (
        <div className={`lds-ring ${extraClass}`}>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    );
}